import React, { useMemo, useState } from "react";
import AdminPanel from "../shared/AdminPanel";
import panelStyles from "../styles/Panel.module.css";
import styles from "../styles/MailingSection.module.css";
import { formatEta } from "../utils/formatters";

function MailingSectionBody({ title = "Рассылки", state, actions, selectors }) {
  const {
    mailingData,
    mailingImages,
    mailingButtons,
    mailingSending,
    mailingResult,
    mailingFileKey,
    mailingProgress,
    mailingStartFromUserId,
    mailingRate,
    mailingPreview,
    mailingDisabled
  } = state;

  const [quickPayProductId, setQuickPayProductId] = useState(1);
  const [quickPayDiscount, setQuickPayDiscount] = useState(0);

  const quickPayLabel = useMemo(() => {
    if (quickPayProductId === 2) return "Оплатить Pro";
    if (quickPayProductId === 3) return "Оплатить Max";
    if (quickPayProductId === 15) return "Lite (неделя)";
    if (quickPayProductId === 16) return "Pro (неделя)";
    if (quickPayProductId === 17) return "Max (неделя)";
    return "Оплатить Lite";
  }, [quickPayProductId]);

  return (
    <>
      <div className={styles.form}>
        <textarea
          rows={6}
          className={panelStyles.textarea}
          placeholder={`Текст для раздела «${title}»`}
          value={mailingData.text}
          onChange={(event) => actions.setMailingData({ ...mailingData, text: event.target.value })}
        />

        <div className={styles.row}>
          <select
            value={mailingData.target}
            className={panelStyles.select}
            onChange={(event) => actions.setMailingData({ ...mailingData, target: event.target.value })}
          >
            <option value="all">Все пользователи</option>
            <option value="conversations">Диалоги</option>
            <option value="donates">Только донаты</option>
            <option value="ever_paid">Хотя бы раз оплатили</option>
            <option value="new">Новые пользователи</option>
            <option value="test">Тест (только админы)</option>
          </select>
          <input
            type="number"
            min="0"
            className={panelStyles.input}
            placeholder="Начать после user ID"
            value={mailingStartFromUserId}
            onChange={(event) => actions.setMailingStartFromUserId(event.target.value)}
          />
        </div>

        <div className={styles.row}>
          <div className={panelStyles.note}>Скорость: {Math.max(1, Number(mailingRate || 1))} / сек</div>
          <input
            type="range"
            min="1"
            max="100"
            step="1"
            value={mailingRate}
            onChange={(event) => actions.setMailingRate(Number(event.target.value))}
          />
        </div>

        <div className={panelStyles.note}>
          Примерное время: {formatEta(selectors.getEstimatedEtaSec())}
          {mailingPreview && Number.isFinite(mailingPreview.startOffset)
            ? ` | Осталось после offset: ${mailingPreview.remaining}`
            : ""}
        </div>

        <div className={styles.buttonActions}>
          <button type="button" className={panelStyles.buttonSecondary} onClick={() => actions.addButton("url")}>
            Добавить URL-кнопку
          </button>
          <button type="button" className={panelStyles.buttonSecondary} onClick={() => actions.addButton("callback")}>
            Добавить callback-кнопку
          </button>
        </div>

        <div className={styles.row}>
          <select
            value={quickPayProductId}
            className={panelStyles.select}
            onChange={(event) => setQuickPayProductId(Number(event.target.value))}
          >
            <option value={1}>Lite</option>
            <option value={2}>Pro</option>
            <option value={3}>Max</option>
            <option value={15}>Lite (неделя)</option>
            <option value={16}>Pro (неделя)</option>
            <option value={17}>Max (неделя)</option>
          </select>
          <input
            type="number"
            min="0"
            max="99"
            className={panelStyles.input}
            placeholder="Скидка %"
            value={quickPayDiscount}
            onChange={(event) => setQuickPayDiscount(Number(event.target.value))}
          />
          <button
            type="button"
            className={panelStyles.buttonSecondary}
            onClick={() => {
              const discount = Math.max(0, Math.min(99, Number(quickPayDiscount || 0)));
              const payload = { command: "broadcast_payment_offer", productId: Number(quickPayProductId || 1), discount };
              actions.addButton("callback", {
                text: discount > 0 ? `${quickPayLabel} (-${discount}%)` : quickPayLabel,
                value: JSON.stringify(payload)
              });
            }}
          >
            Добавить кнопку оплаты
          </button>
        </div>

        {mailingButtons.length > 0 ? (
          <div className={styles.buttonList}>
            {mailingButtons.map((button, index) => (
              <div key={button.id} className={styles.buttonCard}>
                <div className={styles.buttonHeader}>
                  <strong>Кнопка #{index + 1}</strong>
                  <div className={styles.buttonControls}>
                    <button
                      type="button"
                      className={panelStyles.buttonSecondary}
                      onClick={() => actions.moveButton(button.id, "up")}
                      disabled={index === 0}
                    >
                      Вверх
                    </button>
                    <button
                      type="button"
                      className={panelStyles.buttonSecondary}
                      onClick={() => actions.moveButton(button.id, "down")}
                      disabled={index === mailingButtons.length - 1}
                    >
                      Вниз
                    </button>
                    <button
                      type="button"
                      className={panelStyles.buttonSecondary}
                      onClick={() => actions.removeButton(button.id)}
                    >
                      Удалить
                    </button>
                  </div>
                </div>

                <div className={styles.row}>
                  <select
                    value={button.type}
                    className={panelStyles.select}
                    onChange={(event) => actions.updateButton(button.id, { type: event.target.value })}
                  >
                    <option value="url">URL</option>
                    <option value="callback">Callback</option>
                  </select>
                  <input
                    type="text"
                    className={panelStyles.input}
                    placeholder="Текст кнопки"
                    value={button.text}
                    onChange={(event) => actions.updateButton(button.id, { text: event.target.value })}
                  />
                </div>

                <input
                  type="text"
                  className={panelStyles.input}
                  placeholder={button.type === "url" ? "https://..." : "payload"}
                  value={button.value}
                  onChange={(event) => actions.updateButton(button.id, { value: event.target.value })}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className={panelStyles.note}>Кнопки не настроены.</div>
        )}

        <input
          type="text"
          className={panelStyles.input}
          placeholder="Вложения VK: wall-123_456, video-123_456, photo-123_456"
          value={mailingData.attachments}
          onChange={(event) => actions.setMailingData({ ...mailingData, attachments: event.target.value })}
        />

        <div className={styles.row}>
          <input key={mailingFileKey} type="file" accept="image/*" multiple onChange={actions.setImagesFromEvent} />
          <div className={styles.files}>
            {mailingImages.length > 0
              ? mailingImages.map((file) => (
                  <span key={`${file.name}-${file.lastModified}`} className={styles.fileChip}>
                    {file.name}
                  </span>
                ))
              : "Изображения не выбраны"}
          </div>
        </div>

        <div className={panelStyles.note}>
          Для вложений укажите entity id VK через запятую. На одну рассылку можно добавить до 10 изображений.
        </div>

        <div className={styles.buttonActions}>
          <button type="button" className={panelStyles.button} onClick={actions.send} disabled={mailingDisabled}>
            {mailingSending ? "Отправляем..." : `Запустить ${title.toLowerCase()}`}
          </button>
          <button type="button" className={panelStyles.buttonSecondary} onClick={actions.reset} disabled={mailingDisabled}>
            Сбросить
          </button>
        </div>
      </div>

      {mailingProgress ? (
        <div className={styles.progress}>
          <div>
            {mailingProgress.status === "running"
              ? "Рассылка выполняется"
              : mailingProgress.status === "done"
              ? "Рассылка завершена"
              : "Рассылка завершилась с ошибкой"}
          </div>
          <div className={styles.progressBar}>
            <div
              className={styles.progressFill}
              style={{ width: `${Math.min(100, mailingProgress.percent || 0)}%` }}
            />
          </div>
          <div>
            Отправлено: {mailingProgress.sent} / {mailingProgress.total} (ошибок: {mailingProgress.failed}) |{" "}
            {mailingProgress.percent || 0}%
          </div>
          <div>
            Скорость: {mailingProgress.ratePerSec || "-"} / сек | ETA: {formatEta(mailingProgress.etaSec)}
          </div>
        </div>
      ) : null}

      {mailingResult ? (
        <div className={mailingResult.success ? styles.resultSuccess : styles.resultError}>{mailingResult.message}</div>
      ) : null}
    </>
  );
}

export function MailingSection({ mode = "panel", title = "Рассылки", isOpen = true, onToggle, state, actions, selectors }) {
  if (mode === "page") {
    return <MailingSectionBody title={title} state={state} actions={actions} selectors={selectors} />;
  }

  return (
    <AdminPanel id="mailing" title={title} isOpen={isOpen} onToggle={onToggle}>
      <MailingSectionBody title={title} state={state} actions={actions} selectors={selectors} />
    </AdminPanel>
  );
}

export default MailingSection;
